<template>
  <div
    v-if="isRepeat"
    class="tag tag--white tooltip"
    data-tooltip="Repeated Task"
  >
    <i class="fa fa-wrapper fa-recycle" style="color: green;"></i>
  </div>
</template>
<script>
module.exports = {
  name: "record-repeat-icon",
  props: {
    isRepeat: Boolean
  }
};
</script>
